import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import s from './BottomNav.module.css';

/**
 * ADR-047: four-tab clean nav. No special cases, no "Activities (soon)".
 * Each tab navigates to its route; the active key matches the page that
 * renders <BottomNav active="..." />.
 */
const tabs = [
  { key: 'map',       labelKey: 'nav.map',      path: '/' },
  { key: 'bookshelf', labelKey: 'nav.stories',  path: '/bookshelf' },
  { key: 'practice',  labelKey: 'nav.practice', path: '/workbook' },
  { key: 'profile',   labelKey: 'nav.profile',  path: '/profile' },
];

export default function BottomNav({ active }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <nav aria-label={t('nav.mainNav')} className={s.nav}>
      <div className={s.inner}>
        {tabs.map((tab) => {
          const isActive = active === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => navigate(tab.path)}
              aria-current={isActive ? 'page' : undefined}
              className={`${s.tab} ${isActive ? s.tabActive : ''}`}
            >
              {t(tab.labelKey)}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
